import { useState, type ReactNode } from 'react';
import { SetterContext, ValueContext, type WorkspaceBreadcrumbValue } from './useWorkspaceBreadcrumb';

export function WorkspaceBreadcrumbProvider({ children }: { children: ReactNode }) {
  const [value, setValue] = useState<WorkspaceBreadcrumbValue | null>(null);
  return (
    <SetterContext.Provider value={setValue}>
      <ValueContext.Provider value={value}>{children}</ValueContext.Provider>
    </SetterContext.Provider>
  );
}
